export default "__VITE_ASSET__CKDiL7LL__"